// extracted by mini-css-extract-plugin
export default {"tournament_sub_nav":"TournamentAppNav_tournament_sub_nav__htM45","none_slide":"TournamentAppNav_none_slide__+iQ2w","depth_1_link":"TournamentAppNav_depth_1_link__phQAP"};